import { Component, OnInit } from '@angular/core';
import { UtenteLoggato } from '../../../login/login.model';
import { AuthService } from '../../../shared/services/auth.service';
import { UsersService } from '../../../shared/services';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  user: UtenteLoggato;
  cuaaRappresentante: string;

  constructor(
    private authService: AuthService,
    private usersService: UsersService
  ) { }

  ngOnInit(): void {
    this.usersService.utente
      .subscribe((utente: UtenteLoggato) => {
        this.user = utente;
        const user = JSON.parse(sessionStorage.getItem("user")!) as UtenteLoggato;
        if (user) {
          this.user = user;
        }
        this.cuaaRappresentante = this.user['codiceFiscale'];
      });
  }

}
